/* Boroj — Bundle Builder DOM controller.
 *
 * Every number shown here comes from boroj-discount-rules.js. This file only moves values into the
 * page: it holds no discount logic, because logic in an inline <script> cannot be tested, and the
 * numbers it shows are what a customer decides to buy on.
 *
 * If the engine asset fails to load, the panel degrades to exactly the quantity behaviour the
 * section had before spend rules existed — never to a guess.
 */
(function () {
  'use strict';

  function readJSON(id, fallback) {
    try {
      var el = document.getElementById(id);
      if (!el) return fallback;
      return JSON.parse(el.textContent) || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function idsFrom(el, attr) {
    var v = el && el.getAttribute(attr);
    if (!v) return [];
    return v.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  window.BorojBundleUI = function init(sectionId) {
    var root = document.getElementById('boroj-bundle-' + sectionId);
    if (!root) return;

    var ENGINE = window.BorojDiscountRules || null;
    var cfg = readJSON('boroj-bundle-cfg-' + sectionId, null);
    var L = readJSON('boroj-bundle-labels-' + sectionId, {});

    var minItems = (cfg && cfg.minItems) || 3;
    var maxItems = (cfg && cfg.maxItems) || 10;
    var rulesLive = !!(ENGINE && cfg && cfg.enabled);

    /* Two clocks. Server time decides whether a tier has STARTED, so a device clock running fast
       cannot open a promotion early. The visitor's clock is passed as well and is only ever allowed
       to CLOSE one — which matters when a page is restored from the browser's back-forward cache
       carrying a stale render. If the server time is missing entirely the device clock stands in:
       filtering with an imperfect clock is safe, filtering with none would advertise every
       scheduled tier, expired ones included. */
    var clientIso = new Date().toISOString();
    var nowIso = clientIso;
    if (cfg && typeof cfg.nowEpoch === 'number' && cfg.nowEpoch > 0) {
      nowIso = new Date(cfg.nowEpoch * 1000).toISOString();
    }

    var bundleItems = [];

    var itemsList = root.querySelector('[data-bundle-items]');
    var emptyState = root.querySelector('[data-empty-state]');
    var subtotalEl = root.querySelector('[data-bundle-subtotal]');
    var totalEl = root.querySelector('[data-bundle-total]');
    var savingsEl = root.querySelector('[data-savings-amount]');
    var submitBtn = root.querySelector('[data-bundle-submit]');
    var msgEl = root.querySelector('[data-bundle-msg]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var progressText = root.querySelector('[data-progress-text]');
    var discountPctEl = root.querySelector('[data-discount-pct]');
    var spendBoxEl = root.querySelector('[data-spend-tiers]');
    var spendMsgEl = root.querySelector('[data-spend-msg]');
    var spendUnlockedEl = root.querySelector('[data-spend-unlocked]');
    var spendFillEl = root.querySelector('[data-spend-fill]');
    var spendLadderEl = root.querySelector('[data-spend-ladder]');
    var headlineEl = root.querySelector('[data-bundle-headline]');
    var tabs = root.querySelectorAll('.boroj-bundle-tab');
    var cards = root.querySelectorAll('.boroj-bundle-card');

    /* The headline used to be written from two theme sliders that had drifted from Shopify — it
       promised a discount at 3 items while the checkout was already giving one at 2. Once the sync
       has observed the real ladder, the headline is written from THAT, and the sliders are only a
       fallback for the state before the first sync. */
    /* Every mirrored discount, whichever key it arrived under. */
    function externalList() {
      var e = (cfg && cfg.external) || {};
      return (e.qtyTiers || []).concat(e.discounts || []);
    }

    /* Only the ones this page can evaluate from an item count alone: a quantity minimum, a
       percentage, and no spend condition. A spend-based discount is left to the engine — guessing
       at it from the item count would quote a number the checkout has not agreed to. */
    function countableRungs() {
      return externalList().filter(function (t) {
        return t && t.percent > 0 && t.minQty > 0 && !(t.minSpend > 0) && !(t.minSpendCents > 0);
      });
    }

    (function () {
      if (!headlineEl || !L.headline) return;
      var rungs = countableRungs(), lowest = null;
      for (var i = 0; i < rungs.length; i++) {
        if (!lowest || rungs[i].minQty < lowest.minQty) lowest = rungs[i];
      }
      if (!lowest) return;
      headlineEl.textContent = L.headline.replace('{n}', lowest.minQty).replace('{p}', lowest.percent);
    })();

    // ── formatting ───
    function formatMoney(cents) {
      var n = (cents || 0) / 100;
      if (L.en) return 'LE ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return n.toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (L.currency || 'ج.م');
    }

    // ── tabs ───
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var selected = tab.dataset.tab;
        cards.forEach(function (card) {
          card.classList.toggle('hidden', selected !== 'all' && card.dataset.category !== selected);
        });
      });
    });

    // ── size buttons ───
    root.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.boroj-size-btn');
      if (!sizeBtn) return;

      var card = sizeBtn.closest('.boroj-bundle-card');
      var addBtn = card.querySelector('[data-bundle-add]');
      var priceEl = card.querySelector('.boroj-bundle-price-new');

      card.querySelectorAll('.boroj-size-btn').forEach(function (b) { b.classList.remove('active'); });
      sizeBtn.classList.add('active');

      addBtn.dataset.variantId = sizeBtn.dataset.variantId;
      addBtn.dataset.productPrice = parseInt(sizeBtn.dataset.variantPrice, 10);
      addBtn.dataset.productSize = sizeBtn.textContent.trim();
      priceEl.textContent = formatMoney(parseInt(sizeBtn.dataset.variantPrice, 10));

      var inBundle = bundleItems.some(function (i) { return i.variantId === addBtn.dataset.variantId; });
      addBtn.classList.toggle('in-bundle', inBundle);
      addBtn.querySelector('.btn-text').textContent = inBundle ? L.inBundle : L.addToBundle;
    });

    // ── the quoted numbers ───

    /* The quantity-only rule, used when the engine asset is unavailable. Takes the BEST qualifying
       rung rather than the first match, because Shopify applies the best discount and the two
       sliders are independent — a merchant can set the 3-item discount above the 4-item one. */
    function fallbackPct() {
      var n = bundleItems.length, best = 0;
      var rungs = countableRungs();
      for (var i = 0; i < rungs.length; i++) {
        // the BEST qualifying rung, as Shopify does — never the first match
        if (n >= rungs[i].minQty && rungs[i].percent > best) best = rungs[i].percent;
      }
      return best;
    }

    function bundleLines() {
      return bundleItems.map(function (i) {
        return {
          variantId: i.variantId, productId: i.productId, collectionIds: i.collectionIds,
          priceCents: i.price, qty: 1
        };
      });
    }

    function summarise() {
      var subtotal = bundleItems.reduce(function (a, i) { return a + i.price; }, 0);
      if (!ENGINE || !cfg) {
        var pct = fallbackPct();
        var saved = Math.round(subtotal * pct / 100);
        return {
          percent: pct, source: pct > 0 ? 'quantity' : 'none', subtotalCents: subtotal,
          savingsCents: saved, totalCents: subtotal - saved, next: null, tier: null, degraded: true
        };
      }
      return ENGINE.evaluate({
        now: nowIso,
        clientNow: clientIso,
        cart: cfg.cart,
        bundle: bundleLines(),
        rules: cfg.enabled ? cfg.rules : [],
        external: cfg.external,
        showRestricted: !!cfg.showRestricted
      });
    }

    function updateUI() {
      emptyState.style.display = bundleItems.length === 0 ? 'block' : 'none';
      root.querySelectorAll('.boroj-bundle-item').forEach(function (el) { el.remove(); });

      bundleItems.forEach(function (item, idx) {
        var div = document.createElement('div');
        div.className = 'boroj-bundle-item';
        div.innerHTML =
          '<div class="boroj-bundle-item-img"><img src="' + item.image + '" alt=""></div>' +
          '<div class="boroj-bundle-item-info">' +
            '<p class="boroj-bundle-item-title"></p>' +
            '<p class="boroj-bundle-item-size"></p>' +
            '<p class="boroj-bundle-item-price">' + formatMoney(item.price) + '</p>' +
          '</div>' +
          '<button class="boroj-bundle-item-remove" data-remove-idx="' + idx + '">×</button>';
        div.querySelector('.boroj-bundle-item-title').textContent = item.title;
        div.querySelector('.boroj-bundle-item-size').textContent = item.size;
        itemsList.appendChild(div);
      });

      var sum = summarise();

      subtotalEl.textContent = formatMoney(sum.subtotalCents);
      savingsEl.textContent = sum.savingsCents > 0 ? '- ' + formatMoney(sum.savingsCents) : '-';
      totalEl.textContent = formatMoney(sum.totalCents);
      if (discountPctEl) {
        discountPctEl.textContent = sum.percent > 0 ? '(' + sum.percent + '%)'
          : (sum.savingsCents > 0 ? '(' + formatMoney(sum.savingsCents) + ')' : '');
      }

      renderRules(sum);

      var pct = Math.min((bundleItems.length / minItems) * 100, 100);
      progressFill.style.width = pct + '%';
      var remaining = minItems - bundleItems.length;
      progressText.textContent = bundleItems.length >= minItems
        ? L.ready
        : ((remaining === 1 ? (L.addN1 || L.addN) : L.addN) || '').replace('{n}', remaining);

      submitBtn.disabled = bundleItems.length < minItems;

      root.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
        var inBundle = bundleItems.some(function (i) { return i.variantId === btn.dataset.variantId; });
        btn.classList.toggle('in-bundle', inBundle);
        btn.querySelector('.btn-text').textContent = inBundle ? L.inBundle : L.addToBundle;
      });
    }

    /* The ladder and the progress copy. Only tiers the engine considers advertisable appear — a
       scheduled-out, segment-restricted or unenforceable tier is not a rung, because a customer
       who reached it would not be given it. */
    function renderRules(sum) {
      if (!spendBoxEl) return;
      if (!rulesLive) { spendBoxEl.style.display = 'none'; return; }
      spendBoxEl.style.display = 'block';

      if (spendLadderEl && !spendLadderEl.dataset.built) {
        spendLadderEl.dataset.built = '1';
        var rungs = ENGINE.normaliseRules(cfg.rules)
          .filter(function (r) { return r.enabled; })
          .reduce(function (acc, r) { return acc.concat(r.tiers); }, [])
          // the same test the quote uses, so a rung can never appear that the total does not honour
          .filter(function (t) {
            return ENGINE.advertisable(t, Date.parse(nowIso), !!cfg.showRestricted, Date.parse(clientIso));
          });
        rungs.forEach(function (t) {
          var row = document.createElement('div');
          row.className = 'boroj-spend-tier-row';
          row.dataset.tierId = t.id;
          var goal = document.createElement('span');
          goal.className = 'boroj-spend-tier-goal';
          goal.textContent = t.minSpendCents > 0 ? formatMoney(t.minSpendCents)
            : (L.qtyGoal || '{n}').replace('{n}', t.minQty);
          var val = document.createElement('span');
          val.className = 'boroj-spend-tier-pct';
          val.textContent = t.value.type === 'percentage' ? t.value.percent + '%' : formatMoney(t.value.amountCents);
          row.appendChild(goal);
          row.appendChild(val);
          if (t.label) row.title = t.label;
          spendLadderEl.appendChild(row);
        });
      }

      if (spendLadderEl) {
        var appliedIds = (sum.applied || []).map(function (a) { return a.tierId; });
        var reachedCents = sum.tier && sum.tier.minSpendCents ? sum.tier.minSpendCents : -1;
        spendLadderEl.querySelectorAll('.boroj-spend-tier-row').forEach(function (row) {
          var isCurrent = appliedIds.indexOf(row.dataset.tierId) !== -1;
          var thisCents = parseInt((row.dataset.tierId || '').split(':')[1], 10);
          row.classList.toggle('current', isCurrent);
          row.classList.toggle('reached', isCurrent || (!isNaN(thisCents) && thisCents <= reachedCents));
        });
      }

      var copy = ENGINE.progressText(sum, cfg.messages, formatMoney);
      if (spendUnlockedEl) spendUnlockedEl.textContent = copy.unlocked;
      if (spendMsgEl) spendMsgEl.textContent = copy.next;
      if (spendFillEl) spendFillEl.style.width = copy.percentToNext + '%';

      /* When a discount the builder does not own is paying more, say so plainly. The total already
         reflects the winner, and an unexplained mismatch reads as a bug. */
      if (spendMsgEl && sum.source === 'external' && L.otherWins) {
        spendMsgEl.textContent = L.otherWins.replace('{pct}', sum.percent);
      }
    }

    // ── add / remove / submit ───
    root.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-bundle-add]');
      if (!addBtn) return;

      if (bundleItems.length >= maxItems) {
        showMsg((L.maxReached || '').replace('{n}', maxItems), 'error');
        return;
      }
      bundleItems.push({
        productId: addBtn.dataset.productId,
        variantId: addBtn.dataset.variantId,
        collectionIds: idsFrom(addBtn.closest('.boroj-bundle-card'), 'data-collection-ids'),
        title: addBtn.dataset.productTitle,
        size: addBtn.dataset.productSize,
        price: parseInt(addBtn.dataset.productPrice, 10),
        image: addBtn.dataset.productImage,
        url: addBtn.dataset.productUrl
      });
      updateUI();
    });

    itemsList.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-remove-idx]');
      if (!removeBtn) return;
      bundleItems.splice(parseInt(removeBtn.dataset.removeIdx, 10), 1);
      updateUI();
    });

    submitBtn.addEventListener('click', function () {
      if (bundleItems.length < minItems) return;
      submitBtn.disabled = true;
      submitBtn.textContent = L.adding;

      var cartItems = bundleItems.reduce(function (acc, item) {
        var existing = acc.find(function (i) { return i.id === item.variantId; });
        if (existing) { existing.quantity += 1; } else { acc.push({ id: item.variantId, quantity: 1 }); }
        return acc;
      }, []);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.href = L.cartUrl || '/cart'; })
        .catch(function () {
          showMsg(L.error, 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = L.submitAll;
        });
    });

    function showMsg(text, type) {
      msgEl.textContent = text;
      msgEl.className = 'boroj-bundle-msg ' + type;
      setTimeout(function () { msgEl.className = 'boroj-bundle-msg'; }, 3000);
    }

    updateUI();
  };
})();
